/**
 * Базовая карточка документа.
 *
 * @property {string} id
 * @property {string} dbId
 * @property {string} title
 * @property {string} type
 * @property {string} number
 * @property {string} statusId
 * @property {string|null} statusDate
 * @property {string} statusHint
 * @property {string|null} approvalDate
 */
export default class ApiDocumentBaseCard {
  constructor(props) {
    Object.assign(this, props);
  }

  /**
   * @param {Array<{name: string}>} statuses
   * @returns {string|null}
   */
  getStatusName(statuses) {
    return statuses[this.statusId] ? statuses[this.statusId].name : null;
  }

  /**
   * @param {Array<{icon: string}>} statuses
   * @returns {string|null}
   */
  getStatusIcon(statuses) {
    return statuses[this.statusId] ? statuses[this.statusId].icon : null;
  }
}
